import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose, branch, renderComponent } from 'recompose'
import T from 'i18n-react'
import { isNil } from 'ramda'

import SpecItem from 'components/custom/SpecItem/index'
import CpmDetailsEdit from './CpmDetailsEdit'
import styles from './styles.scss'
import { FILTER_ALL } from 'containers/Project/Specifications/constants';
import { SPEC_ORDER } from './constants'

class CpmDetailsSpec extends Component {
  renderItems() {
    const {
      cpmDetails
    } = this.props

    const moduleOrder = SPEC_ORDER;

    var cpmDetailsItem = moduleOrder.map((property, index) => {
      const propertyData = cpmDetails[property]
      const label = T.translate(`project.cpmDetails.${property}`);
      if (isNil(propertyData)) return
      return (
        <SpecItem
          key={index}
          label={label}
          initValue={''}
          modifiedValue={propertyData}
          isModifiedPage={false}
          risk={false}
          curFilter={FILTER_ALL}
          curStatus={null}
        />
      )
    })
    // filter null values
    .filter(val => val)

    return (
      <div>
        <div styleName='specItemCommon'>
          { cpmDetailsItem }
        </div>
      </div>
    )
  }

  render() {
    const items = this.renderItems()
    return(
      <div styleName='cpm_details'>
        { items }
      </div>
    )
  }
}

const withBranch = branch(({edit}) => edit, renderComponent(CpmDetailsEdit))
const withStyles = CSSModules(styles)
const enhance = compose(
  withBranch,
  withStyles
)

export default enhance(CpmDetailsSpec)
